import type { Environment } from 'types/environment'
import { getAllMarkets } from 'lib/storefronts'

export function isValidEnvironmentCountryCode(isoCode: string): isoCode is Environment.CountryCode {
  return getAllMarkets().some(market => market.countryCode === isoCode)
}
